"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
var _defineProperty = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranscriptEventConverter = void 0;
var SignalingProtocol_1 = require("../signalingprotocol/SignalingProtocol");
var Transcript_1 = require("./Transcript");
var TranscriptionStatus_1 = require("./TranscriptionStatus");
var TranscriptionStatusType_1 = require("./TranscriptionStatusType");
var TranscriptItemType_1 = require("./TranscriptItemType");
var TranscriptionStatusTypes = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, SignalingProtocol_1.SdkTranscriptionStatus.Type.STARTED, TranscriptionStatusType_1.default.STARTED), SignalingProtocol_1.SdkTranscriptionStatus.Type.INTERRUPTED, TranscriptionStatusType_1.default.INTERRUPTED), SignalingProtocol_1.SdkTranscriptionStatus.Type.RESUMED, TranscriptionStatusType_1.default.RESUMED), SignalingProtocol_1.SdkTranscriptionStatus.Type.STOPPED, TranscriptionStatusType_1.default.STOPPED), SignalingProtocol_1.SdkTranscriptionStatus.Type.FAILED, TranscriptionStatusType_1.default.FAILED);
var TranscriptEventConverter = /*#__PURE__*/function () {
  function TranscriptEventConverter() {
    _classCallCheck(this, TranscriptEventConverter);
  }
  _createClass(TranscriptEventConverter, null, [{
    key: "from",
    /**
     * Decodes a list of TranscriptEvent from a data message.
     * @param dataMessage Data message to decode from
     * @returns List of TranscriptEvent
     * @throws {Error} If the data message payload cannot be decoded
     */
    value: function from(dataMessage) {
      var frame;
      try {
        frame = SignalingProtocol_1.SdkTranscriptFrame.decode(dataMessage.data);
      } catch (e) {
        throw new Error('Cannot decode transcript data message: ' + e);
      }
      var transcriptEvents = [];
      var _iterator = _createForOfIteratorHelper(frame.events),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var sdkTranscriptEvent = _step.value;
          if (sdkTranscriptEvent.status) {
            var transcriptionStatusType = TranscriptionStatusTypes[sdkTranscriptEvent.status.type];
            if (!transcriptionStatusType) {
              continue;
            }
            var transcriptionStatus = new TranscriptionStatus_1.default();
            transcriptionStatus.type = transcriptionStatusType;
            transcriptionStatus.eventTimeMs = sdkTranscriptEvent.status.eventTime;
            transcriptionStatus.transcriptionRegion = sdkTranscriptEvent.status.transcriptionRegion;
            transcriptionStatus.transcriptionConfiguration = sdkTranscriptEvent.status.transcriptionConfiguration;
            if (sdkTranscriptEvent.status.message) {
              transcriptionStatus.message = sdkTranscriptEvent.status.message;
            }
            transcriptEvents.push(transcriptionStatus);
          } else if (sdkTranscriptEvent.transcript) {
            var transcript = new Transcript_1.default();
            transcript.results = [];
            var _iterator2 = _createForOfIteratorHelper(sdkTranscriptEvent.transcript.results),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var result = _step2.value;
                var transcriptResult = {
                  channelId: result.channelId,
                  isPartial: result.isPartial,
                  resultId: result.resultId,
                  startTimeMs: result.startTime,
                  endTimeMs: result.endTime,
                  alternatives: []
                };
                if (result.languageCode) {
                  transcriptResult.languageCode = result.languageCode;
                }
                if (result.languageIdentification && result.languageIdentification.length > 0) {
                  transcriptResult.languageIdentification = [];
                  var _iterator3 = _createForOfIteratorHelper(result.languageIdentification),
                    _step3;
                  try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                      var languageIdentification = _step3.value;
                      var transcriptLanguageWithScore = {
                        languageCode: languageIdentification.languageCode,
                        score: languageIdentification.score
                      };
                      transcriptResult.languageIdentification.push(transcriptLanguageWithScore);
                    }
                  } catch (err) {
                    _iterator3.e(err);
                  } finally {
                    _iterator3.f();
                  }
                }
                var _iterator4 = _createForOfIteratorHelper(result.alternatives),
                  _step4;
                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    var alternative = _step4.value;
                    var transcriptAlternative = {
                      items: [],
                      transcript: alternative.transcript
                    };
                    var _iterator5 = _createForOfIteratorHelper(alternative.items),
                      _step5;
                    try {
                      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                        var item = _step5.value;
                        var transcriptItem = {
                          content: item.content,
                          attendee: {
                            attendeeId: item.speakerAttendeeId,
                            externalUserId: item.speakerExternalUserId
                          },
                          startTimeMs: item.startTime,
                          endTimeMs: item.endTime,
                          type: null
                        };
                        if (item.vocabularyFilterMatch) {
                          transcriptItem.vocabularyFilterMatch = item.vocabularyFilterMatch;
                        }
                        if (item.hasOwnProperty('stable')) {
                          transcriptItem.stable = item.stable;
                        }
                        if (item.hasOwnProperty('confidence')) {
                          transcriptItem.confidence = item.confidence;
                        }
                        switch (item.type) {
                          case SignalingProtocol_1.SdkTranscriptItem.Type.PRONUNCIATION:
                            transcriptItem.type = TranscriptItemType_1.default.PRONUNCIATION;
                            break;
                          case SignalingProtocol_1.SdkTranscriptItem.Type.PUNCTUATION:
                            transcriptItem.type = TranscriptItemType_1.default.PUNCTUATION;
                            break;
                        }
                        transcriptAlternative.items.push(transcriptItem);
                      }
                    } catch (err) {
                      _iterator5.e(err);
                    } finally {
                      _iterator5.f();
                    }
                    var _iterator6 = _createForOfIteratorHelper(alternative.entities),
                      _step6;
                    try {
                      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                        var entity = _step6.value;
                        if (!transcriptAlternative.entities) {
                          transcriptAlternative.entities = [];
                        }
                        var transcriptEntity = {
                          category: entity.category,
                          confidence: entity.confidence,
                          content: entity.content,
                          startTimeMs: entity.startTime,
                          endTimeMs: entity.endTime
                        };
                        if (entity.type) {
                          transcriptEntity.type = entity.type;
                        }
                        transcriptAlternative.entities.push(transcriptEntity);
                      }
                    } catch (err) {
                      _iterator6.e(err);
                    } finally {
                      _iterator6.f();
                    }
                    transcriptResult.alternatives.push(transcriptAlternative);
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }
                transcript.results.push(transcriptResult);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
            transcriptEvents.push(transcript);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return transcriptEvents;
    }
  }]);
  return TranscriptEventConverter;
}();
exports.TranscriptEventConverter = TranscriptEventConverter;